<template>
    <div id="shippingscosts-modal-wrapper" class="shippingCostModal">
        <div id="shippingscosts" role="dialog" class="modal fade" aria-modal="true" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title h3">Versandkosten</div>
                        <button type="button" data-dismiss="modal" aria-hidden="true" class="close">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="buttonScroller">
                            <div :class="'buttonHolder loc_' + localization.localeClient">
                                <button v-for="(region, index) in regions" :key="index"
                                    :class="['btn', 'btn-bkm-white', region.class, { 'active': activeRegion === index }]"
                                    @click="setActiveRegion(index)">
                                    {{ region.label }}
                                </button>
                            </div>
                        </div>
                        <div class="contentHolder" :class="{'loading': isLoading }">
                            <div class="table">
                                <div class="line" v-for="service in shippingServices"
                                    :class="{'active': shippingProvider == service.type}">
                                    <span class="nameLogo">
                                        <img v-if="service.gogreen" class="gogreen" alt="DHL GoGreen"
                                            src="https://cdn.bio-kinder.de/frontend/resources/img/footer/gogreen.svg" />
                                        <img v-if="service.co2neutral" class="gogreen" alt="CO2-neutraler Versand"
                                            src="https://cdn.bio-kinder.de/frontend/resources/img/footer/co2neutral-paket.svg" />
                                        <span class="serviceName">{{ service.name }}</span>
                                    </span>
                                    <div class="prices">
                                        <span class="cost">{{ service.cost }}</span>
                                        <span class="additionalInfo" v-if="additionalInfo != ''"
                                            v-html="additionalInfo"></span>
                                    </div>
                                    <ul class="optionalDetails" v-if="service.details">
                                        <li v-for="detail in service.details" v-html="detail"></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="fair">
                                <span class="headline"
                                    v-html="$translate('biokinderDesign::Template.shippingModalFairShipping')"></span>
                                <p v-html="$translate('biokinderDesign::Template.shippingModalFairDescription')"></p>
                            </div>
                            <div class="details">
                                <p v-html="$translate('biokinderDesign::Template.shippingModalDetails')"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ModalService from "../../services/ModalService";
import { isDefined } from "../../helper/utils";

export default {
    name: "shipping-costs",
    data() {
        return {
            activeRegion: 0, 
            modalElement: 'shippingscosts',
            regions: [
                { label: 'Deutschland', class: 'germany' },
                { label: 'Österreich', class: 'austria' },
                { label: 'EU & CH', class: 'europe' },
                { label: 'Weltweit', class: 'wordlwide' }
            ]  
        };
    },
    computed:
    {
        selectedRegion() {
            if(this.selectedCountryId < 3)
                return this.selectedCountryId - 1; // 1 = de, 2 = at
            
            if(this.isEU)
                return 2;

            return 3;
        },
        additionalInfo()
        {
            if (this.activeRegion > 1)
                return "";

            return '';
        },
        isEU() {
            if(this.selectedCountryId == 4) 
                return true; // Schweiz = EU&CH

            return !!this.localization.euShippingCountries.find((country) => { return country.id === this.selectedCountryId });
        },
        shippingProvider() {
            if ([28, 50, 13, 20, 21, 15, 41, 57, 61].includes(this.systemShippingProfile) && this.basket.itemQuantity > 0) 
                return 'parcel';
            
            if ([7, 22, 23, 43, 44, 45].includes(this.systemShippingProfile)) 
                return 'freight';
            
            if ([11, 46, 53].includes(this.systemShippingProfile)) 
                return 'letter';
            
            if ([13].includes(this.systemShippingProfile)) 
                return 'pickup';
            
            return 'none';
        },
        shippingServices()
        {
            let services = [
                [ // DE
                    { name: 'Kleinpaket', gogreen: false, co2neutral: true, cost: "2,95 €", type: "letter" },
                    { name: 'Paket', gogreen: false, co2neutral: true, cost: "5,95 € - 29,95 € *", type: "parcel" },
                    {
                        name: 'DHL Spedition', gogreen: true, co2neutral: false, cost: "39,95 € - 59,95 € *", type: "freight",
                        details: [
                            'telefonische Terminvereinbarung zur Lieferung',
                            'Lieferung mit einem 2-Mann-Team bis zum Aufstellort im Wohnraum'
                        ]
                    }
                ],
                [ // AT
                    // { name: 'Kleinpaket', gogreen: false, co2neutral: true, cost: "8,95 €", type: "letter" },
                    { name: 'Paket', gogreen: false, co2neutral: true, cost: "12,95 € - 49,95 *", type: "parcel" },
                    {
                        name: 'DHL Spedition', gogreen: true, co2neutral: false, cost: "99,95 € - 129,95 € *", type: "freight",
                        details: [
                            'telefonische Terminvereinbarung zur Lieferung',
                            'Lieferung mit einem 2-Mann-Team bis zum Aufstellort im Wohnraum'
                        ]
                    }
                ],
                [ // EU & CH
                    { name: 'Abholung in Wehrheim', gogreen: false, co2neutral: true, cost: "0,00 €", type: "pickup" },
                    { name: 'Paket', gogreen: false, co2neutral: true, cost: "ab 12,95 € *", type: "parcel" },
                    {
                        name: 'Spedition', gogreen: false, co2neutral: false, cost: "ab 249,95 € *", type: "freight",
                        details: [
                            'telefonische Terminvereinbarung zur Lieferung',
                            'Lieferung bis zur Bordsteinkante'
                        ]
                    }
                ],
                [ // WW
                    { name: 'Abholung in Wehrheim', gogreen: false, co2neutral: true, cost: "0,00 €", type: "pickup" },
                    { name: 'Paket', gogreen: false, co2neutral: true, cost: "auf Anfrage", type: "parcel" },
                    { name: 'Spedition', gogreen: false, co2neutral: false, cost: "auf Anfrage", type: "freight" }
                ]
            ]

            return services[this.activeRegion] ?? services[0];
        },
        ...mapState({
            basket: state => state.basket.data,
            selectedCountryId: state => state.basket.data.shippingCountryId,
            systemShippingProfile: state => state.basket.data.shippingProfileId,
            localization: state => state.localization,
            isLoading: state => state.localization.localeLoading
        })
    },
    methods: {
        setActiveRegion(index) {
            this.activeRegion = index;
        },
        initModalEventListeners() {
            const modal = ModalService.findModal(document.getElementById(this.modalElement));

            if (isDefined(modal)) {
                modal.on("show.bs.modal",
                    () => {
                        this.setActiveRegion(this.selectedRegion);
                    });
            }
        }
    },
    watch: {
        selectedRegion(newValue) {
            this.setActiveRegion(newValue);
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.modalElement) {
                this.initModalEventListeners();
            }
        });
    }

}
</script>
